import React, { useEffect, useState } from 'react';
import './css/AdminPanel.css';
import { getSystemSettings, saveSystemSettings } from '../../Utils/RestUtils';
import { ERROR_TEXT } from '../../Utils/Constants/GlobalConstants';
import {
  PAYMENT_TEST,
  SELL_ON_STOP,
  SUCCESSFULLY_UPDATED,
} from '../../Utils/Constants/AdminConstants';

const settingsFields = [
  { key: 'paymentTest', title: PAYMENT_TEST },
  { key: 'sellOnStop', title: SELL_ON_STOP },
];

function SystemSettings() {
  const [settings, setSettings] = useState({
    paymentTest: false,
    sellOnStop: false,
  });
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const showMessage = (text, error) => {
    setMessage(text);
    setIsError(error);
  };

  useEffect(() => {
    getSystemSettings()
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          const { paymentTest, sellOnStop } = response.data[0];
          setSettings({
            paymentTest: paymentTest === true,
            sellOnStop: sellOnStop === true,
          });
        }
      })
      .catch(() => {
        showMessage(ERROR_TEXT, true);
      });
  }, []);

  const handleToggle = (key) => {
    if (isSaving) {
      return;
    }

    const token = window.localStorage.getItem('accessToken');
    const payload = { ...settings, [key]: !settings[key] };
    setIsSaving(true);

    saveSystemSettings(payload, token)
      .then((response) => {
        if (response && response.data) {
          const { paymentTest, sellOnStop } = response.data;
          setSettings({ paymentTest, sellOnStop });
          showMessage(SUCCESSFULLY_UPDATED, false);
        } else {
          showMessage(ERROR_TEXT, true);
        }
      })
      .catch(() => {
        showMessage(ERROR_TEXT, true);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const getToggleClass = (key) =>
    `ap_toggle ${settings[key] ? 'ap_toggle_on' : ''}`;

  const renderSettings = () =>
    settingsFields.map((field) => (
      <button
        key={`ap-system-${field.key}`}
        type="button"
        className="ap_toggle_line br_text_16"
        onClick={() => handleToggle(field.key)}
        disabled={isSaving}
      >
        <div className={getToggleClass(field.key)}>
          <div className="ap_toggle_knob" />
        </div>
        <div>{field.title}</div>
      </button>
    ));

  return (
    <div className="ap_panel">
      {renderSettings()}
      {message.length > 0 && (
        <div
          className={`ap_message br_text_14 ${
            isError ? 'ap_message_error' : ''
          }`}
        >
          {message}
        </div>
      )}
    </div>
  );
}

export default SystemSettings;
